module.exports = __webpack_public_path__ + "static/media/19ESCAP49.7f701d70.jpg";